import { useZCalendarWebApiHandler_performTourAction } from '@zg-rentals/ts-z-calendar-client-react-query';

import { ZCALENDAR_TOURS_QUERY_TAG } from '../constants/queryTags';

type Options = {
  /** Names the consuming surface in error logs, e.g. 'TourCancellationModal - Error cancelling tour'. */
  errorDetails: string;
};

/**
 * Mutation for landlord-initiated tour actions (confirm/cancel/decline). Invalidates queries
 * tagged with ZCALENDAR_TOURS_QUERY_TAG on success (requires the consuming app's query client to
 * handle meta.tags/meta.invalidates).
 */
const usePerformTourAction = ({ errorDetails }: Options) =>
  useZCalendarWebApiHandler_performTourAction({
    meta: {
      invalidates: [ZCALENDAR_TOURS_QUERY_TAG],
      context: {
        api: 'performTourAction',
        details: errorDetails,
      },
    },
  });

export default usePerformTourAction;
